import axios from "axios";
import Vue from "vue";
import objectUtils from "../../util/objectUtils";
import helper from "../../util/helper";

export default {
  state: () => ({
    selectedResource: {},
    resources: [],
    resourcesWithAllCategories: [],
    resourcesWithAllCategoriesTree: [],
  }),

  mutations: {
    setSelectedResource(state, resourceGroup) {
      Vue.set(state, "selectedResource", resourceGroup);
    },
    setResources(state, resources) {
      Vue.set(state, "resources", resources);
    },
    setResourcesWithAllCategories(state, resources) {
      Vue.set(state, "resourcesWithAllCategories", resources);
    },
    setResourcesWithAllCategoriesTree(state, resources) {
      Vue.set(state, "resourcesWithAllCategoriesTree", resources);
    },
    setDefaultResourceModule(state, resources) {
      Vue.set(state, "selectedResource", {});
      Vue.set(state, "resources", []);
      Vue.set(state, "resourcesWithAllCategories", []);
      Vue.set(state, "resourcesWithAllCategoriesTree", []);
    },
  },

  actions: {
    //TODO: load, update, create
    createResource: (context, request) => {
      return axios
        .post(context.getters.getMcServiceUrl + "/resources/entity", request, {})
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },

    loadResources: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/resources/entity").then((response) => {
        context.commit("setSelectedResource", response.data);
        return objectUtils.convertPublishModelToUpdateModel(response.data);
      });
    },

    loadPublishedResources: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/resources/entity/published").then((response) => {
        return response.data;
      });
    },

    loadSelectedResourceHistory: (context, resourceGroup) => {
      return axios.get(context.getters.getMcServiceUrl + "/resources/history/" + resourceGroup.id, {}).then((response) => {
        return response.data;
      });
    },

    deleteResource: (context, resourceGroup) => {
      return axios
        .delete(context.getters.getMcServiceUrl + "/resources/entity/" + resourceGroup.id)
        .then((response) => {
          let intents = [];
          intents.push(response.data);
          resourceGroup.intents = intents;
          resourceGroup.intentId = response.data.id;
          return resourceGroup;
        })
        .catch((err) => {
          if (err.response.status === 400) {
            context.commit("setWarningModalContent", err.response.data.message);
            return "warning";
          }
        });
    },
    deleteDraftResource: (context, resourceGroup) => {
      return axios
        .delete(context.getters.getMcServiceUrl + "/resources/draft/" + resourceGroup.intentId)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          if (err.response.status === 400) {
            context.commit("setWarningModalContent", err.response.data.message);
            return "warning";
          }
        });
    },

    publishResource: (context, resourceGroup) => {
      return axios.get(context.getters.getMcServiceUrl + "/resources/publish/" + resourceGroup.intentId).then((response) => {
        if (response.data) {
          response.data.intentId = 0;
        }
        //Fixme: intents type CREATE_STATION ise get isteği atılmalı.
        if (resourceGroup.intents[0].type === "DELETE_RESOURCE_GROUP") {
          let resources = context.getters.getSegments;
          resources.splice(resources.indexOf(resourceGroup), 1);
          context.commit("setResources", resources);
        }
        return response.data;
      });
    },

    rejectResource: (context, resourceGroup) => {
      return axios.get(context.getters.getMcServiceUrl + "/resources/reject/" + resourceGroup.intentId).then((response) => {
        helper.recallOrRejectEntity(resourceGroup, "resources");
        return response.data;
      });
    },

    sendToApprovalResources: (context, resourceGroup) => {
      return axios.get(context.getters.getMcServiceUrl + "/resources/sendToApproval/" + resourceGroup.intentId).then((response) => {
        if (resourceGroup.intents[0].type === "CREATE_RESOURCE_GROUP") {
          resourceGroup.intents[0].status = "WAITING_APPROVAL";
        } else if (resourceGroup.intents[0].type === "UPDATE_RESOURCE_GROUP") {
          resourceGroup.intents[0].status = "WAITING_APPROVAL";
        }
        return response.data;
      });
    },

    recallResource: (context, resourceGroup) => {
      return axios.get(context.getters.getMcServiceUrl + "/resources/recall/" + resourceGroup.intentId).then((response) => {
        helper.recallOrRejectEntity(resourceGroup, "resources");
        return response.data;
      });
    },

    loadResourcesWithAllCategories: (context) => {
      return axios.get(context.getters.getMcServiceUrl + "/resources/entity/categories").then((response) => {
        context.commit("setResourcesWithAllCategories", response.data);
        return response.data;
      });
    },

    loadResourcesWithAllCategoriesTree: (context) => {
      return axios.get(context.getters.getMcServiceUrl + "/resources/entity/categories-tree").then((response) => {
        context.commit("setResourcesWithAllCategoriesTree", response.data);
        return response.data;
      });
    },
  },

  getters: {
    getSelectedResource: (state) => {
      return state.selectedResource;
    },
    getResources: (state) => {
      return state.resources;
    },
    getPublishedResources: (state) => {
      return state.resources.filter((entity) => {
        return entity.intentId === 0;
      });
    },
    getResourcesWithAllCategories: (state) => {
      return state.resourcesWithAllCategories;
    },
    getResourcesWithAllCategoriesTree: (state) => {
      return state.resourcesWithAllCategoriesTree;
    },
  },
};
